import ky from "ky";
export const httpClient = ky.extend({
    credentials: "include"
});
